import { useEffect } from 'react';
import { RaRecord, useStore } from 'react-admin';

type UseSelectedColumnsParams<T extends RaRecord> = {
  preferences: string;
  defaultColumns: (keyof T)[];
  persist?: boolean;
};

export const useSelectedColumns = <T extends RaRecord>({
  preferences,
  defaultColumns,
  persist = true,
}: UseSelectedColumnsParams<T>) => {
  const [columnsList, setColumnsList] = useStore<(keyof T)[]>(
    `preferences.${preferences}`,
    defaultColumns,
  );

  useEffect(() => {
    if (!persist) {
      setColumnsList(defaultColumns);
    }
  }, [persist, defaultColumns, setColumnsList]);

  return columnsList;
};
